import { Component } from '@angular/core';
import { TabComponent } from '../../../components/tab/tab.component';
import { APITableComponent } from '../../../components/table/api-table/api-table.component';
import { TabLayoutComponent } from '../../../components/tab-layout/tab-layout.component';

@Component({
  selector: 'app-on-field-activities-tab',
  imports: [APITableComponent, TabLayoutComponent],
  templateUrl: './on-field-activities-tab.component.html',
  providers: [
    { provide: TabComponent, useExisting: OnFieldActivitiesTabComponent },
  ],
})
export class OnFieldActivitiesTabComponent extends TabComponent {
  override name = this.dictionaryService.get('On Field Activities');

  readonly endpoint = '/visits/tables/supervisors-on-field';

  public async main(): Promise<void> {}
}
